/* Smartparts24 · Wow-Layer: Reveals, Zähler, Parallax, Magnet, Fortschritt.
   Nur transform/opacity, respektiert prefers-reduced-motion, keine Abhängigkeiten. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  root.classList.add('sp24-js');

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---------- Fortschrittsbalken + Header-Schatten ---------- */
    var prog = d.createElement('div');
    prog.className = 'sp24-progress';
    prog.setAttribute('aria-hidden', 'true');
    prog.innerHTML = '<span class="sp24-progress__bar"></span>';
    d.body.appendChild(prog);
    var bar = prog.firstChild, ticking = false;
    var hero = d.querySelector('[data-sp24-hero]');
    function onScroll() {
      var y = window.pageYOffset || root.scrollTop;
      var max = Math.max(1, root.scrollHeight - window.innerHeight);
      bar.style.transform = 'scaleX(' + Math.min(1, y / max).toFixed(4) + ')';
      root.classList.toggle('sp24-scrolled', y > 8);
      if (hero && !reduce) {
        var h = hero.offsetHeight || 1;
        var p = Math.min(1, Math.max(0, y / h));
        hero.style.setProperty('--sp-scroll', p.toFixed(3));
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();

    /* ---------- Scroll-Reveals ---------- */
    var targets = [];
    function add(sel, cls, stagger) {
      var list = d.querySelectorAll(sel);
      Array.prototype.forEach.call(list, function (el, i) {
        if (el.classList.contains('sp24-reveal')) return;
        if (el.closest('.m-scroll-trigger, [data-sp24-hero], .m-header, .m-footer')) return;
        if (el.classList.contains('m-scroll-trigger')) return;
        el.classList.add('sp24-reveal');
        if (cls) el.classList.add(cls);
        if (stagger) el.style.setProperty('--sp-delay', ((i % 6) * 80) + 'ms');
        targets.push(el);
      });
    }
    add('.m-section__header, .sp24-cards__heading, .sp24-cards__description, .sp24-products__header, .sp24-faq h2, .sp24-head');
    add('.sp24-cards__card, .sp24-step, .sp24-stat, .sp24-trust__item, .sp24-faq details', null, true);
    add('.sp24-feature__content', 'sp24-reveal--left');
    add('.sp24-feature--image-left .sp24-feature__content', 'sp24-reveal--right');
    add('.sp24-feature__media', 'sp24-reveal--scale');
    add('[data-sp24-reveal]');

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('sp24-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sp24-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      targets.forEach(function (el) { io.observe(el); });
    }

    /* ---------- Zähler ---------- */
    var counters = d.querySelectorAll('[data-sp24-count]');
    function fmt(n) { try { return n.toLocaleString('de-DE'); } catch (e) { return String(n); } }
    function run(el) {
      var to = parseFloat(el.getAttribute('data-sp24-count')) || 0;
      if (reduce) { el.textContent = fmt(to); return; }
      var dur = 1600, t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = fmt(Math.round(to * e));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.6 });
      Array.prototype.forEach.call(counters, function (el) { cio.observe(el); });
    } else {
      Array.prototype.forEach.call(counters, function (el) { el.textContent = fmt(parseFloat(el.getAttribute('data-sp24-count')) || 0); });
    }

    /* ---------- Hero: Maus-Parallax ---------- */
    if (hero && hover && !reduce) {
      var raf = 0, mx = 0, my = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(function () {
          hero.style.setProperty('--sp-mx', mx.toFixed(3));
          hero.style.setProperty('--sp-my', my.toFixed(3));
          raf = 0;
        });
      });
      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--sp-mx', 0);
        hero.style.setProperty('--sp-my', 0);
      });
    }

    /* ---------- Magnetische Buttons ---------- */
    if (hover && !reduce) {
      Array.prototype.forEach.call(d.querySelectorAll('.sp24-hero .m-button, .sp24-magnetic'), function (btn) {
        btn.classList.add('sp24-magnetic');
        btn.addEventListener('pointermove', function (e) {
          var r = btn.getBoundingClientRect();
          var x = (e.clientX - (r.left + r.width / 2)) / r.width;
          var y = (e.clientY - (r.top + r.height / 2)) / r.height;
          btn.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px,' + (y * 8).toFixed(1) + 'px)';
        });
        btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
      });

      /* ---------- Leichter 3D-Tilt auf Bildkarten ---------- */
      Array.prototype.forEach.call(d.querySelectorAll('.sp24-cards__card--image'), function (card) {
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'perspective(900px) rotateX(' + (-y * 4).toFixed(2) + 'deg) rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-6px)';
        });
        card.addEventListener('pointerleave', function () { card.style.transform = ''; });
      });
    }

    /* ---------- Schritte: Linie zeichnen ---------- */
    var steps = d.querySelector('.sp24-steps');
    if (steps) {
      if (reduce || !('IntersectionObserver' in window)) steps.classList.add('sp24-in');
      else {
        var sio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { steps.classList.add('sp24-in'); sio.disconnect(); } });
        }, { threshold: 0.25 });
        sio.observe(steps);
      }
    }
  });
})();
